import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function CategoryNav() {
  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">
            热门<span className="text-primary-500">分类</span>
          </h2>
          <p className="text-sm text-foreground-500 mt-3">选择你感兴趣的分类，发现更多精彩内容</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-6 rounded-xl bg-background-100 hover:bg-primary-50 transition-all duration-300 hover:scale-105 cursor-pointer"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl bg-primary-100 text-primary-500 group-hover:bg-primary-500 group-hover:text-white transition-all duration-300">
                <i className={`${cat.icon} text-2xl`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 whitespace-nowrap">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-400">{cat.count}条内容</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}